import { __assign, __rest } from "tslib";
import React, { isValidElement, forwardRef } from 'react';
import RcTooltip from 'rc-tooltip';
import { usePrefix } from '../ConfigProvider';
import { useGetPopupContainer } from '../PopupContainerProvider';
export default forwardRef(function Tooltip(props, ref) {
    var title = props.title, _a = props.placement, placement = _a === void 0 ? 'top' : _a, children = props.children, prefixCls = props.prefixCls, overlayClassName = props.overlayClassName, rest = __rest(props, ["title", "placement", "children", "prefixCls", "overlayClassName"]);
    var prefix = usePrefix('tooltip', prefixCls);
    var getPopupContainer = useGetPopupContainer();
    return (React.createElement(RcTooltip, __assign({ ref: ref, prefixCls: prefix, placement: placement, overlay: title, overlayClassName: overlayClassName, getTooltipContainer: getPopupContainer }, rest), isValidElement(children) ? children : React.createElement("span", null, children)));
});
//# sourceMappingURL=index.js.map